module.exports = __webpack_public_path__ + "static/media/deliver.60a84113.png";